import CacheMan from "../../jslibs/CacheMan"
import GError from "../../jslibs/GError"
import JWTApi from "./JWTApi"

export default class Usernames extends CacheMan<string,string> {
    private _api:JWTApi|undefined

    static _i:Usernames
    static get i(){
        if (!this._i) this._i = new Usernames("usernames", 3600)
        return this._i
    }

    init(jwt:JWTApi){
        this._api = jwt
        return this
    }

    get api(){
        if (this._api) return this._api
        else throw new GError.SystemError("Usernames is not initialized")
    }
    fetch(key: string): Promise<string> {
        return this.api.api.get<string[]>("/1/names/" + key).then(data => data.data[0])
    }

    fetchBatch(keys: string[]): Promise<string[]> {
        return this.api.api.get<string[]>("/1/names/"+keys.join(",")).then(data => data.data)
    }
}